import { useSelector } from 'react-redux';
import { RootState } from '@/store/store';
import { Navigate, useLocation } from 'react-router-dom';

interface PermissionGuardProps {
    children: React.ReactNode;
    requiredPermissions: string[];
}

const PermissionGuard = ({ children, requiredPermissions }: PermissionGuardProps) => {
    const { permissions: userPermissions } = useSelector((state: RootState) => state.auth);
    const location = useLocation();

    const hasPermission = requiredPermissions.some(permission =>
        userPermissions.includes(permission)
    );

    const hasSuperAdminPermission = userPermissions.includes("ROLE_SUPER_ADMIN");

    if (!hasPermission && !hasSuperAdminPermission) {
        return <Navigate to="/dashboard/forbidden" state={{ from: location }} replace />;
    }

    return <>{children}</>;
};

export default PermissionGuard; 